import { classes, selectors } from './lib';

export const showPopup = async (ref) => {
	// Show the popup with the given ID
	const popup = document.querySelector(`${selectors.popupContainer}[data-popup-ref="${ref}"]`);
	if (!popup) {
		console.error(`Error showing popup "${ref}": Popup with that reference not found.`);
		return;
	}

	popup.hidden = false;

	// Show the popup container and add the visible class
	document.querySelector(`${selectors.popupContainer}[data-popup-ref="${ref}"]`).classList.toggle(classes.visibleClass, true);
	document.querySelector('body').classList.add(classes.popupOpen);
};

export const hidePopup = () => {
	document.querySelector('body').classList.remove(classes.popupOpen);

	document.querySelectorAll(selectors.popupContainer).forEach((popup) => {
		popup.classList.remove(classes.visibleClass);
		popup.hidden = true;
	});

	// Stop YouTube videos
	document.querySelectorAll(`${selectors.popupVideos}, ${selectors.selfHostedVideo}`).forEach((video) => {
		// check if video is playing
		let src = video.getAttribute('src');
		if (!src) {
			return;
		}

		src = src.replace('autoplay=1', 'autoplay=0');
		src = src.replace('mute=1', 'mute=0');
		video.setAttribute('src', src);
	});
};
